'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';
import AccountView from '../views/AccountView.vue';
import { accountEventRoutes } from '../../event/routes/event-routes';

// Account child routes
let accountChildRoutes = [
  {
    path: '',
    name: 'account',
    props: true,
    component: () => import('../views/AccountDetailView.vue'),
  },
  {
    path: 'change-password',
    name: 'account.change-password',
    component: () => import('../../../auth/views/ChangePasswordView.vue'),
  },
  {
    path: 'organizer',
    name: 'account.organizer',
    component: () => import('../views/AccountOrganizerView.vue'),
  },
];
accountChildRoutes = accountChildRoutes.concat(accountEventRoutes);

export const accountRoutes = [
  {
    path: '/account',
    component: AccountView,
    children: accountChildRoutes,
  },
];
